export default {
  agreed: 'Accepté',
  searchStatement: "Conditions d'utilisation de la recherche",
  noData: 'Plus de données',
  starts: 'Étoile',
  searching: 'Recherche en cours',
  searchService: "Rechercher les conditions d'utilisation",
  filter: {
    performanceQuality: 'Qualité de la performance',
    comprehensiveExperienceScore: "Score d'expérience global",
    fourStartDown: 'Moins de quatre étoiles',
    certifiedFactory: 'Usine certifiée',
    dayYield: 'Taux de rendement sur 24 heures',
    doubleDayYield: 'Taux de rendement sur 48 heures',
    performanceGuarantee: 'Garantie de performance',
    dayShipments: 'Expédition le jour même',
    strictSelect: 'Sélection stricte',
    disStrictSelect: 'Sélection stricte de la distribution',
    dayShip: 'Livraison en 24 heures',
    doubleDayShip: 'Livraison en 48 heures',
    sevenDayNoReason: 'Sept jours sans motif',
    oneIssuing: "Prise en charge de l'expédition en une seule pièce",
    onePostIssuing:
      'Prise en charge de la livraison gratuite (livraison gratuite pour une seule pièce)',
    sevenDayNew: '7 jours pour les nouveaux produits',
    thirtyDayNew: '30 jours pour les nouveaux produits',
    wordStrictSelect: 'Sélection stricte mondiale',
    isSelect: 'Palettes de sélection transfrontalières',
    priceSort: 'Classement par prix',
    compositeSort: 'Classement général',
    up: 'Réduire',
    reset: 'Réinitialiser',
    moreFilters: 'Plus de critères de filtre',
    bestMatch: 'Meilleure correspondance',
    saleHighToLow: 'Ventes : Du plus haut au plus bas',
    saleLowToHigh: 'Ventes : Du plus bas au plus haut',
    priceHighToLow: 'Prix : Du plus haut au plus bas',
    priceLowToHigh: 'Prix : Du plus bas au plus haut',
    fastToSlow: 'Délai de livraison : Du plus rapide au plus lent',
    slowToFast: 'Délai de livraison : Du plus lent au plus rapide',
  },
}
